import { useGetCompanyQuery } from "features/api/company"

export function useIsEcommerceEnabled(): boolean {
  const { data } = useGetCompanyQuery({})
  return !!data?.company?.ecommerceSettings?.isEcommEnabled
}
